var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6465 12.0057C23.6465 18.6198 18.3403 23.9998 11.8214 23.9998C5.31423 23.9998 0 18.6198 0 12.0057C0 5.39984 5.31423 0.0117188 11.8214 0.0117188C18.3403 0.0117188 23.6465 5.39984 23.6465 12.0057ZM6.61524 16.0443L5.90969 17.5743C5.80197 17.8185 6.03817 18.0223 6.23536 17.9414L7.80393 17.2623L16.0895 8.88414L14.881 7.65789L6.61524 16.0443ZM16.2737 6.26051L15.513 7.03221L16.7217 8.25021L17.4741 7.48676C17.8347 7.11723 17.8436 6.7287 17.514 6.39876L17.3233 6.20071C17.0054 5.87819 16.6232 5.91861 16.2737 6.26051Z",
    fill: "#344BBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0c8afb7b4c4474b34be568d980e424dd.svg";
export { ForwardRef as ReactComponent };